import { Injectable } from '@angular/core';
import { HttpSecureClient } from 'path-shared/services/http/httpSecureClient';
import { AuthGuardService } from 'path-shared/services/authentication/auth-guard.service';
import { Observable } from 'rxjs';
import { AparellTipus } from '../models/aparellTipus.model';
import { config } from 'path-shared/configuration/config';
import { api } from 'path-shared/configuration/urls';
import { AparellTipusFilter } from '../models/aparellTipus-filter';
import { AparellTipusFilterService } from './aparellTipus-filter.service';

const defaultSortParam = 'id';
const defaultSortDirection = 'desc';

@Injectable()
export class AparellTipusService {
  constructor(private http: HttpSecureClient, private authGuard: AuthGuardService) {}

  getAll(): Observable<any> {
    if (this.authGuard.canActivate()) {
      const params = new AparellTipusFilterService().createFilterParams(new AparellTipusFilter('id', 'asc'), 0, 99999, 'id', 'asc');
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlGetAparellsTipus'],  params);
    }
  }

  setAparellTipus(sigla: AparellTipus): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.post(config.urls['apiUrl'] + api.endpoints['urlSetAparellTipus'], sigla);
    }
  }

  removeAparellTipus(secure_id): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.delete(config.urls['apiUrl'] + api.endpoints['urlDeleteAparellTipus'].replace('{secure_id}', secure_id), null);
    }
  }

  getAparellTipus(secure_id): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlGetAparellTipus'].replace('{secure_id}', secure_id), null);
    }
  }

  generateExcel(filter: AparellTipusFilter, sortDir: string, sortField: string): Observable<any> {
    const start = 0;
    const pageSize = 1000;

    sortField = sortField === undefined ? defaultSortParam : sortField;
    sortDir = sortDir === '' ? defaultSortDirection : sortDir;
    const params = new AparellTipusFilterService().createFilterParams(filter, start, pageSize, sortField, sortDir);

    if (this.authGuard.canActivate()) {
      return this.http.getFile(config.urls['apiUrl'] + api.endpoints['urlAparellTipusExcel'],  params );
    }
  }
}
